import { Injectable } from '@angular/core';

import { ApiHttpClient } from '../../../infrastructure/infrastructure.module';

import { Observable } from 'rxjs';
import { api } from '@bayclubs/utils'
import { camps } from '../../models/models.generated';

@Injectable()
export class StatisticsApiService {

    constructor(private http: ApiHttpClient) { }

    public getSystem(request: camps.StatisticsRequest): Observable<api.OperationResultValue<camps.SystemStatistics>> {
        return this.http.post<api.OperationResultValue<camps.SystemStatistics>>(`statistics/system`, request, false);
    }

    public getTransactionsOverview(request: camps.ChartDataRequest): Observable<api.OperationResultValue<camps.TransactionsDataResponse>> {
        return this.http.post<api.OperationResultValue<camps.TransactionsDataResponse>>(`statistics/transactions`, request, false);
    }

    public getRevenueOverview(request: camps.ChartDataRequest): Observable<api.OperationResultValue<camps.RevenueDataResponse>> {
        return this.http.post<api.OperationResultValue<camps.RevenueDataResponse>>(`statistics/revenue`, request, false);
    }
}
